import React from "react";
import MOTPerformanceReport from "./MOTPerformanceReport";

// MOT Retailer dashboard — same component, different team filter.
const MOTRetailerPerformanceReport = (props) => (
    <MOTPerformanceReport {...props} team="MOT-RET" title="MOT Retailer Performance Report" />
);

export default MOTRetailerPerformanceReport;
